import { useFrame, useLoader } from "@react-three/fiber";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DoubleSide, TextureLoader } from "three";
import gift1 from "./item/g2.png";
import Question from "./question";
import { GIFT_DATA } from "./data";

function Gift({ data, camera, randomShow, sceneKey }) { // sceneKey là prop đại diện cho scene hiện tại
  const ref = useRef();
  const [randomItem, setRandomItem] = useState(null);
  const materialRef = useRef();
  const [isShowQuestion, setIsShowQuestion] = useState(false);

  const texture = useLoader(TextureLoader, gift1);

  // Khi scene thay đổi (sceneKey), vị trí của hộp quà sẽ được random lại
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * GIFT_DATA.position.length);
    setRandomItem(GIFT_DATA.position[randomIndex]); // Random lại vị trí khi sceneKey thay đổi
    setIsShowQuestion(false); // Reset câu hỏi khi chuyển scene
  }, [sceneKey]); // Mỗi khi sceneKey thay đổi (tức là scene mới được render)

  useFrame(({ state, clock, gl, camera }) => {
    if (ref.current) {
      const time = clock.getElapsedTime();
      const percent = (1 + Math.sin(time * 2)) / 2;
      const opacity = 0.5 + 0.5 * percent;
      const scale = 2 + 0.5 * percent;

      ref.current.scale.set(scale, scale, scale);
      materialRef.current.opacity = opacity;
      if (gl.xr.isPresenting) {
        ref.current.lookAt(camera.position);
      } else {
        ref.current.quaternion.copy(camera.quaternion);
      }
    }
  });

  const onPointerEnter = useCallback(() => {
    document.body.style.cursor = "pointer";
    ref.current.scale.set(2.5, 2.5, 2.5);
  }, []);

  const onPointerLeave = useCallback(() => {
    document.body.style.cursor = "default";
    ref.current.scale.set(2, 2, 2);
  }, []);

  console.log('randomItem', randomItem);

  const onClose = useCallback(() => {
    randomShow(0.1);
    setIsShowQuestion(false);
  }, [randomShow]);

  if (!randomItem) return null;

  return (
    <>
      {isShowQuestion && <Question camera={camera} onClose={onClose} />}
      <mesh
        position={[randomItem.x * 0.9, randomItem.y * 0.9, randomItem.z * 0.9]}
        ref={ref}
        onClick={() => {
          setIsShowQuestion(true);
          if (window.firstClick === undefined) {
            window.firstClick = true;
          }
        }}
        scale={2}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
      >
        <planeGeometry args={[40, 40]} />
        <meshBasicMaterial
          ref={materialRef}
          side={DoubleSide}
          map={texture}
          transparent
          opacity={1}
          alphaTest={0.5}
        />
      </mesh>
    </>
  );
}

export default Gift;
